import React, { FC, PropsWithChildren, useState, useEffect } from "react";
import useTheme from "../context/Theme/useTheme";
import Sidebar from "../Components/Sidebar";
import { useLocation } from "react-router-dom";
import style from './style.module.css'

const Layout: FC<PropsWithChildren> = ({ children }) => {
  const theme = useTheme();
  const location = useLocation();
  const [sidebarWidth, setSidebarWidth] = useState(240);
  const [isSidebarHidden, setIsSidebarHidden] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  // Don't show sidebar on auth page
  const showSidebar = location.pathname !== "/auth";

  // Listen for sidebar width and visibility changes
  useEffect(() => {
    const handleWidthChange = (event: CustomEvent) => {
      setSidebarWidth(event.detail);
    };

    const handleVisibilityChange = (event: CustomEvent) => {
      setIsSidebarHidden(event.detail);
    };

    const handleStorageChange = () => {
      const width = localStorage.getItem('sidebarWidth');
      if (width) {
        setSidebarWidth(parseInt(width));
      }
    };

    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    // Load initial width from localStorage
    const initialWidth = localStorage.getItem('sidebarWidth');
    if (initialWidth) {
      setSidebarWidth(parseInt(initialWidth));
    }

    window.addEventListener('sidebarWidthChange', handleWidthChange as EventListener);
    window.addEventListener('sidebarVisibilityChange', handleVisibilityChange as EventListener);
    window.addEventListener('storage', handleStorageChange);
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('sidebarWidthChange', handleWidthChange as EventListener);
      window.removeEventListener('sidebarVisibilityChange', handleVisibilityChange as EventListener);
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // On mobile, CSS handles full-width layout — skip inline styles that would override media queries
  const mainContentStyle = (!isMobile && showSidebar && !isSidebarHidden)
    ? { marginLeft: `${sidebarWidth}px`, width: `calc(100% - ${sidebarWidth}px)` }
    : {};

  return (
    <div style={{ backgroundColor: theme.palette.background }} className={style.layout}>
      <div className={style.contentWrapper}>
        {showSidebar && <Sidebar isMobile={isMobile} />}
        <div
          className={`${style.mainContent} ${showSidebar ? style.withSidebar : ''}`}
          style={mainContentStyle}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default Layout;
